import {
  Checkbox, FormControlLabel, Tab, Tabs,
} from '@mui/material';
import type { PropsWithChildren } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { JobType } from '../../../../../entities';
import { AppConstantsContext } from '../../../../../context';

type ModelOption = 'universal' | 'rock' | 'classic';

const useStyles = makeStyles()(() => ({
  body: {
    width: '100%',
    paddingLeft: '10px',
    paddingTop: '20px',
    // borderRadius: '0 12px 12px 12px',
    // backgroundColor: alpha(theme.palette.primary.main, 0.2),
  },
  autoDetection: {
    margin: '10px',
    paddingBottom: '14px',
  },
}));

interface InstrumentsDetectionWrapperProps extends PropsWithChildren {
  onDetectionChange?: (detection: boolean) => void;
  model?: ModelOption;
  onModelChange?: (model: ModelOption) => void;
  showModels: boolean;
  children: React.ReactNode;
}

const InstrumentsDetectionWrapper: React.FC<InstrumentsDetectionWrapperProps> = ({
  onDetectionChange,
  showModels,
  children,
  model = 'universal',
  onModelChange,
}) => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const { jobType } = React.useContext(AppConstantsContext);

  const handleDetectionChange = (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
    onDetectionChange?.(checked);
  };

  if (jobType === JobType.TranscribeStudio) {
    return (
      <>
        {showModels && (
          <Tabs
            variant="fullWidth"
            value={model}
            onChange={(_e, newValue) => onModelChange?.(newValue as ModelOption)}
            aria-label="model selection tabs"
          >
            <Tab
              id="model_universal"
              value="universal"
              label={t('home.input.dialog.choose_instrument.model.universal')}
            />
            <Tab
              id="model_rock"
              value="rock"
              label={t('home.input.dialog.choose_instrument.model.rock')}
            />
            <Tab
              id="model_classic"
              value="classic"
              label={t('home.input.dialog.choose_instrument.model.classic')}
            />
          </Tabs>
        )}

        <div className={classes.body}>
          {children}
          <div className={classes.autoDetection}>
            <FormControlLabel
              control={
                <Checkbox size="small" id="auto_detection" onChange={handleDetectionChange} />
              }
              label={t('home.input.dialog.choose_instrument.detect_instrument')}
            />
          </div>
        </div>
      </>
    );
  }
  return <div>{children}</div>;
};

export default InstrumentsDetectionWrapper;
